<template>
  <div>
    <div class="top">
      <div class="wrap">

        <div class="title">{{first.title}}</div>
        <div class="info">{{first.sdesc}}</div>
        <div class="btns">
          <span class="btn1" @click="goDetail(first.id)">探索了解</span>
          <span class="btn2" @click="goDetail(first.id,'buy')">选购</span>
        </div>
      </div>
    </div>

    <div class="list">
      <div class="item" v-for="(item,index) in list" :key="index">
        <img src="@/assets/icon_home_banner.png">
        <div class="item_content">
          <div class="title">{{item.title}}</div>
          <div class="line"></div>
          <div class="info card-desc">{{item.sdesc}}</div>
          <div class="btns">
            <span class="btn1" @click="goDetail(item.id)">探索了解</span>
            <span class="btn2" @click="goDetail(item.id,'buy')">选购</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/components/eventBus.js";
import { mapGetters,mapActions } from 'vuex';
export default {
  name: "HomeView",
  data() {
    return {
      first:{},
      list:[]
    };
  },
  computed: {
    ...mapGetters(['base'])
  },
  created(){
    this.getBase();
  },
  mounted() {},
  methods: {
    ...mapActions(['getConfig']),
    
    getBase(){
      this.getConfig((data)=>{
        console.log('获取配置成功',data);
        let arr = [];
        data.category.map(item=>{
          if(item.child.length > 0){
            item.child.map(item2=>{
              arr.push(item2);
            })
          }
        })
        this.first = arr[0];
        this.list = arr.slice(1);
      })
    },
    goDetail(id,type){
      this.$router.push({
        path:'/cellslineinfo/'+id,
        query:{to:type}
      })
    }
  }
};
</script> 

<style lang="less"  scoped>
.top {
  background-image: url("@/assets/icon_home_bg.png");
  width: 100%;
  height: 550px;
  background-size: cover;
  background-repeat: no-repeat;
  padding-top: 90px;
  
  .wrap{
    width: 100%;
    height: 100%;
    position: relative;
    top: -100px;
    margin-top: 100px;
    display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  }
  .title {
    font-size: 36px;
    color: #333333;
    font-weight: 500;
  }
  .info {
    width: 40%;
    margin-top: 25px;
    line-height: 36px;
    font-size: 20px;
    color: #333333;
  }
  .btns {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    color: #ffffff;
    margin-top: 30px;
  }
  .btn1 {
    cursor: pointer;
    width: 90px;
    height: 40px;
    background: #3c9c8f;
    margin-right: 40px;
  }

  .btn2 {
    cursor: pointer;
    width: 90px;
    height: 40px;
    background: #e69f3e;
  }
}
.list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap; 
  box-sizing: border-box; 
  margin-left: 1.5%; 
  margin-top: 10px;
  .item { 
    width: 48%;
    height: 450px;
    margin-top: 15px;
    margin-bottom: 15px;
    margin-right: 2%;
  }
  .item img {
    position: absolute; 
    height: 450px; 
    width: 48%;
  }
  .item_content {
    position: relative;
    display: flex;
    flex-direction: column; 
    height: 450px;
    padding-left: 50%;
    padding-top: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    box-sizing: border-box; 
    .title {
      font-size: 36px;
      color: #333333;
      font-weight: 500;
      line-height: 52px;
    }
    .line {
      background: #3c9c8f;
      height: 2px;
      width: 80px;
    }
    .info {
      width: 92%;
      margin-top: 25px;
      line-height: 36px;
      font-size: 20px;
      color: #333333;
    }
    .card-desc {
      flex: 1;
      overflow: hidden;
    }
    .btns {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
      color: #ffffff;
      margin-top: 30px;
    }
    .btn1 {
      width: 90px;
      height: 40px;
      background: #3c9c8f;
      margin-right: 40px;
    }

    .btn2 {
      width: 90px;
      height: 40px;
      background: #e69f3e;
    }
  }
}
</style>

